import React, { useEffect, useState } from "react";
import { CalendarMonth, Close, DashboardOutlined, ExitToApp, GroupWorkOutlined, HotelOutlined, KeyboardArrowRight, Logout, Menu as MenuIcon, SettingsOutlined, StorefrontOutlined } from "@mui/icons-material";
import DatePicker from "react-datepicker";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { parseISO } from "date-fns";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import { BarLoader } from "react-spinners";
import { Tooltip } from "react-tooltip";
import { selectCompany, selectCompanyType, selectPrefix, selectUserName, selectUserType, selectWidth } from "./utility/Redux/profile";
import { SelectDate, setDate } from "./utility/Redux/refresh";
import { selectStatus, setAlertWithTitle, setCustomeTwoButtomAlert } from "./utility/Redux/modal";
import CustomeTwoButtonAlert from "./utility/component/modals/twoButtonAlert";
import SpinnerLoading from "./utility/component/modals/spinnerLoading";
import SessionOutModal from "./utility/component/modals/sessionExpired";
import AlertModal2 from "./utility/component/modals/alertWithLottie";
import { HandleIndexedDB } from "./utility/indexDb";
import GarmentDashboard from "./Dashboard/dashboard3";
import HotalResDashboard from "./Dashboard/hotal_res_dashboard";
import "./home.css";
import "./dashboard-palette.css";
import "./dashboard-layout-fix.css";
import "./sidebar-refinement.css";
import "./running-tables.css";
import "./front-office.css";
import "./calendar-ui.css";

const Home = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dateOpen, setDateOpen] = useState(false);
  const [expiredIn, setExpiredIn] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const companyname = useSelector(selectCompany);
  const companyType = useSelector(selectCompanyType);
  const userType = useSelector(selectUserType);
  const userName = useSelector(selectUserName);
  const prefix = useSelector(selectPrefix);
  const selectedDate = useSelector(SelectDate);
  const loading = useSelector(selectStatus);
  const windowWidth = useSelector(selectWidth);

  const menuItems = [
    { label: "Dashboard", icon: <DashboardOutlined />, path: "/" },
    ...(companyType === "Restaurant" || companyType === "Restaurant Hotel" ? [{ label: "Item sales", icon: <StorefrontOutlined />, path: "/item_group" }] : []),
    ...(companyType === "Restaurant Hotel" ? [{ label: "Front office", icon: <HotelOutlined />, path: "/sale_desk_rooms" }] : []),
  ];

  useEffect(() => {
    HandleIndexedDB({ databaseName: "userDetails", storeName: "data", callback: (data) => {
      if (!data?.[0]) return;
      const days = moment(data[0].end_date).diff(moment().startOf("day"), "days");
      if (days < 11) setExpiredIn(days);
      if (days >= 0 && days < 4) dispatch(setAlertWithTitle({ title: "License expiry", msg: `License will expire in ${days} days.` }));
    }});
  }, [dispatch]);

  const chooseMenu = (item) => {
    setMenuOpen(false);
    if (item.path === "/item_group") navigate(item.path, { state: { table_prefix: prefix, from_date: moment().format("YYYY-MM-DD"), to_date: moment().format("YYYY-MM-DD"), itm_group: "" } });
    else navigate(item.path);
  };
  const currentPage = menuItems.find((item) => item.path === location.pathname)?.label || "SalesDesk";

  return <div className="salesdesk-shell">
    <aside className={`salesdesk-sidebar ${menuOpen ? "is-open" : ""}`} aria-label="Main menu">
      <div className="sidebar-brand"><div className="sidebar-logo-lockup"><img className="sidebar-logo-mark" src={require("./utility/images/GOROUND2.png")} alt="" /><img className="sidebar-logo-wordmark" src={require("./utility/images/GO92X12.png")} alt="Genius Office" /></div><button className="sidebar-close" onClick={() => setMenuOpen(false)} aria-label="Close menu"><Close /></button></div>
      <div className="sidebar-heading">MAIN MENU</div>
      <nav className="sidebar-nav">{menuItems.map((item) => <button key={item.path} className={`nav-item ${location.pathname === item.path ? "active" : ""}`} onClick={() => chooseMenu(item)}><span className="nav-icon">{item.icon}</span><span>{item.label}</span><KeyboardArrowRight className="nav-arrow" /></button>)}</nav>
      <div className="sidebar-bottom"><div className="help-card"><span>Need help?</span><small>Contact Genius Office support</small></div><button className="nav-item logout" onClick={() => dispatch(setCustomeTwoButtomAlert({ status: true }))}><span className="nav-icon"><Logout /></span><span>Log out</span></button></div>
    </aside>
    {menuOpen && <button className="menu-overlay" aria-label="Close navigation" onClick={() => setMenuOpen(false)} />}
    <main className="salesdesk-main">
      <header className="topbar print:hidden"><div className="topbar-start"><button className="menu-button" onClick={() => setMenuOpen(true)} aria-label="Open menu"><MenuIcon /></button><div className="mobile-brand">SalesDesk</div><div className="company-context"><span className="company-label">Your business</span><strong>{companyname || "SalesDesk"}</strong></div></div><div className="topbar-user"><div className="user-avatar">{(userName || "U").trim().charAt(0).toUpperCase()}</div><div className="user-copy"><strong>{userName || "User"}</strong><span>{userType || "Team member"}</span></div><button className="logout-top" onClick={() => dispatch(setCustomeTwoButtomAlert({ status: true }))} aria-label="Log out"><ExitToApp /></button></div></header>
      <section className="dashboard-context print:hidden"><div className="page-title"><span>{currentPage}</span>{expiredIn !== "" && <small className="expiry-note">License expires in {expiredIn} days</small>}</div><div className="date-control"><CalendarMonth /><div><span>Showing sales for</span><DatePicker readOnly popperPlacement="bottom-end" open={dateOpen} onInputClick={() => setDateOpen(true)} onClickOutside={() => setDateOpen(false)} onSelect={() => setDateOpen(false)} selected={parseISO(moment(selectedDate).format("YYYY-MM-DD"))} dateFormat="EEE, d MMM yyyy" onChange={(date) => dispatch(setDate(moment(date).format("YYYY-MM-DD")))} /></div></div></section>
      <div className="page-loader"><BarLoader color="#f5874f" loading={loading} width="100%" height={3} /></div>
      <section className="salesdesk-content" onClick={() => menuOpen && setMenuOpen(false)}>{location.pathname === "/" ? (companyType === "Garments" ? <GarmentDashboard /> : <HotalResDashboard />) : <Outlet />}</section>
    </main>
    <CustomeTwoButtonAlert /><SpinnerLoading /><SessionOutModal /><AlertModal2 />
    {windowWidth > 1280 && <Tooltip id="tip" style={{ padding: 3, backgroundColor: "#f7dda4", color: "black" }} />}
  </div>;
};

export default Home;
